'use client'

import { HugeiconsIcon } from '@hugeicons/react'
import { PlusSignIcon, ZapIcon } from '@hugeicons-pro/core-stroke-rounded'
import { NewCommandPopover } from './NewCommandPopover'

export function CommandsEmptyState() {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="mb-4 rounded-2xl bg-atrium-content p-4">
        <HugeiconsIcon icon={ZapIcon} className="size-8 text-atrium-black/50" />
      </div>
      <h2 className="text-lg font-semibold">No commands yet</h2>
      <p className="mt-2 max-w-md text-sm text-atrium-black/50">
        Create your first one.
      </p>
      <div className="mt-6">
        <NewCommandPopover
          trigger={
            <button
              type="button"
              className="bv3-btn-grn"
              style={{ padding: '8px 14px', fontSize: 13, display: 'flex', alignItems: 'center', gap: 6 }}
            >
              <HugeiconsIcon icon={PlusSignIcon} className="size-4" />
              New command
            </button>
          }
        />
      </div>
    </div>
  )
}
